import { Type } from '@angular/core';

export class ComponentOutletComponent<T extends object> {
    constructor(readonly component: Type<T>) {}
}

export type ComponentOutletContent<T extends object> = ComponentOutletComponent<T>;
